import React, { useState, useEffect } from 'react';
import { Card } from '../components/ui/card';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Camera, MapPin } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TedsTravels = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/teds-travels`);
        setPosts(res.data);
      } catch { setPosts([]); }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero */}
      <div className="bg-[#1e3a5f] text-white py-12">
        <div className="container mx-auto px-4 text-center">
          <Camera className="w-12 h-12 mx-auto mb-3 text-red-400" />
          <h1 className="text-3xl sm:text-4xl font-bold mb-2">Truckn Ted's Travels</h1>
          <p className="text-lg text-blue-200">Life on the road — snapshots from across Australia</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        {loading ? (
          <p className="text-center text-gray-500 py-12">Loading...</p>
        ) : posts.length === 0 ? (
          <div className="text-center py-16">
            <Camera className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-600 mb-2">No Photos Yet</h3>
            <p className="text-gray-500">Check back soon for photos from Truckn Ted's adventures!</p>
          </div>
        ) : (
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
            {posts.map(post => (
              <Card key={post.id} className="break-inside-avoid overflow-hidden group cursor-pointer" onClick={() => setLightbox(post)} data-testid={`ted-post-${post.id}`}>
                <div className="relative">
                  <img
                    src={post.photo_data}
                    alt={post.caption || 'Ted\'s Travels'}
                    className="w-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                {post.caption && (
                  <div className="p-4">
                    <p className="text-sm text-gray-700">{post.caption}</p>
                    <p className="text-xs text-gray-400 mt-2">{new Date(post.created_at).toLocaleDateString('en-AU')}</p>
                  </div>
                )}
              </Card>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <div className="max-w-4xl max-h-[90vh] relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setLightbox(null)} className="absolute -top-10 right-0 text-white text-3xl hover:text-gray-300">&times;</button>
            <img src={lightbox.photo_data} alt={lightbox.caption || ''} className="max-w-full max-h-[80vh] rounded-lg object-contain" />
            {lightbox.caption && (
              <p className="text-white text-center mt-4 text-sm max-w-lg mx-auto">{lightbox.caption}</p>
            )}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default TedsTravels;
